<div class="quiz-answer" [class.selected]="correctAnswer().value === index()">
    <p-radiobutton [value]="index()" [inputId]="'correct-' + index()" [formControl]="correctAnswer()" />
    <app-form-input
        [control]="control()"
        [inputId]="'correct-' + index()"
        label
        [placeholder]="'quiz-questions.form.answer.value.placeholder' | translate"
        [testId]="testId() + '-value'"
    />
    <p-button
        class="remove-answer"
        icon="pi pi-trash"
        severity="danger"
        [text]="true"
        [rounded]="true"
        [disabled]="!canRemove()"
        [attr.data-test]="testId() + '-remove'"
        (onClick)="remove.emit()"
    />
</div>
